// extracted by mini-css-extract-plugin
module.exports = {"container":"_20m2bjP34vS3Syt7joC_dE"};